'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentProductDetailComponent = exports.rentProductDetailComponent = {
    template: require('./rent-product-detail.html'),
    bindings: {
        product: '<'
    },
    controllerAs: 'vm',
    controller: ["Enums", "rentalProductsService", "$stateParams", function controller(Enums, rentalProductsService, $stateParams) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.medipimData = null;
        vm.medipimDataLoading = false;
        vm.isEmptyObject = isEmptyObject;
        vm.recommendedRentalProducts = [];
        vm.recommendedPortalProducts = [];
        vm.suggestedRentalProducts = [];
        vm.suggestedPortalProducts = [];

        function init() {
            filterRelatedProducts();
            loadMedipimData();
            vm.attachments = vm.product.attachments;
        }

        function loadMedipimData() {
            vm.medipimDataLoading = true;
            rentalProductsService.getRentalProductMedipimdata($stateParams.productId).then(function (medipimData) {
                vm.medipimDataLoading = false;
                vm.medipimData = medipimData;
            });
        }

        function filterRelatedProducts() {
            vm.recommendedRentalProducts = vm.product.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.RECOM.value && p.productTypeCode === 'RENTAL';
            });
            vm.recommendedPortalProducts = vm.product.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.RECOM.value && p.productTypeCode === 'PORTALPRODUCT';
            });
            vm.suggestedRentalProducts = vm.product.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.INTER.value && p.productTypeCode === 'RENTAL';
            });
            vm.suggestedPortalProducts = vm.product.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.INTER.value && p.productTypeCode === 'PORTALPRODUCT';
            });
        }

        function isEmptyObject(o) {
            if (o) {
                return Object.keys(o).every(function (x) {
                    return o[x] === '' || o[x] === null || o[x] === false || o[x] === 0 || o[x] === undefined;
                });
            } else {
                return true;
            }
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/rent-product-detail.js
// module id = 1028
// module chunks = 0